// src/pages/Signup.js
import React, { useState } from 'react';
import { createUserWithEmailAndPassword  } from 'firebase/auth';
// import { Link } from 'react-router-dom';
import {doc, setDoc} from "firebase/firestore";
import db, { auth } from '../../config/firebaseConfig';
import ReCAPTCHA from 'react-google-recaptcha';
import { createClientOrganizationInFirestore } from '../../utilityFunctions/firestoreUtilities';


function SignupModal({ setShowSignupModal, setShowLoginModal, setShowLoadingModal }) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [organizationName, setOrganizationName] = useState('');
  const [discoveryMethod, setDiscoveryMethod] = useState('')
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please complete the CAPTCHA");
      return;
    }

    if (!organizationName.trim()) {
      alert("Please enter your organization name");
      return;
    }

    try {
      setShowLoadingModal(true);
      console.log("Loading modal set to true");

      // Create user account
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log(userCredential);
      
      // Create a user document in Firestore            
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, {
        email: user.email,
        uid: user.uid,
        discoveryMethod: discoveryMethod,
        signUpDate: new Date(),
      });

      // Create client organization with retry logic
      let retryCount = 0;
      const maxRetries = 3;
      let createdClientOrganizationRef = null;

      while (retryCount < maxRetries && !createdClientOrganizationRef) {
        try {
          createdClientOrganizationRef = await createClientOrganizationInFirestore(organizationName, user.uid);
          const createdClientOrganizationId = createdClientOrganizationRef.id; 
          console.log("Client organization created with ID:", createdClientOrganizationId);
          break; // Success, exit the retry loop
        } catch (error) {
          retryCount++;
          console.error(`Attempt ${retryCount} failed to create client organization:`, error);
          
          if (retryCount >= maxRetries) {
            console.error("Failed to create client organization after all retries");
            alert("Account created but there was an issue setting up your organization. Please contact support.");
            setShowLoadingModal(false);
            return;
          }
          
          // Wait a bit before retrying (exponential backoff)
          await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
        }
      }

      setShowLoadingModal(false);
      window.location.href = '/';
      
    } catch (error) {
      console.error("Error during signup:", error);
      setShowLoadingModal(false);
      alert(error.message || "An error occurred during signup. Please try again or contact support.");
    }
  }
  
  return (
    <div 
      className="modal-overlay" 
      style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
      onClick={() => setShowSignupModal(false)}
    >
      <div 
        className="modal p-4 sm:p-6 lg:p-8 overflow-auto max-h-full mx-4 sm:mx-0" 
        style={{ 
          cursor: 'default', 
          width: '95vw',
          maxWidth: '500px',
          minHeight: 'auto',
          maxHeight: '90vh',
          backgroundColor: 'white', 
          borderRadius: '10px'
        }}
        onClick={(e) => e.stopPropagation()} // Prevent click event from propagating to the overlay
      >
        {/* <div className="self-start mb-4">
          <button 
            onClick={() => window.location.href = 'http://www.withgrantmagic.com'} 
            className="w-30 h-12 p-2 bg-gray-200 hover:bg-gray-300 rounded"
          >
            Return Home
          </button>
        </div> */}

        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h3 className="mt-6 sm:mt-10 text-center text-xl sm:text-2xl font-bold leading-9 tracking-tight">
            Welcome to GrantMagic.
          </h3>
          <h3 className="mt-2 text-center text-md sm:text-xl leading-9 tracking-tight text-gray-500">
            You're one click away from fundraising superpowers. 
          </h3>
        </div>

        <div className="mt-6 sm:mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-4 sm:space-y-6" action="#" method="POST" onSubmit={handleSignUp}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-left">
                Email Address<span className="text-indigo-600"> *</span>
              </label>
              <div className="mt-2">
                <input
                  value={email}
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6">
                  Password<span className="text-indigo-600"> *</span>
                </label>
              </div>
              <div className="mt-2">
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>

            <div>
              <label htmlFor="organizationName" className="block text-sm font-medium leading-6 text-left">
                Organization Name<span className="text-indigo-600"> *</span>
              </label>
              <div className="mt-2">
                <input
                  value={organizationName}
                  onChange={(e) => setOrganizationName(e.target.value)}
                  id="organizationName"
                  name="organizationName"
                  type="text"
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>

            <div>
              <label htmlFor="discoveryMethod" className="block text-sm font-medium leading-6 text-left">
                How did you hear about us?<span className="text-indigo-600"> *</span>
              </label>
              <div className="mt-2">
                <input
                  value={discoveryMethod}
                  onChange={(e) => setDiscoveryMethod(e.target.value)}
                  id="discoveryMethod"
                  name="discoveryMethod"
                  type="text"
                  required
                  className="block w-full rounded-md border-0 py-2 sm:py-1.5 pl-3 sm:pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-base sm:text-sm"
                />
              </div>
            </div>          

            <div className="flex justify-center">
              <div className="transform scale-90 sm:scale-100">
                <ReCAPTCHA
                  sitekey="6LcTwLMqAAAAAGJNb4eqKFfLNw5LgRnhG6w-iK3U"
                  onChange={(value) => setCaptchaValue(value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className={`flex w-full justify-center rounded-md px-3 py-2 sm:py-1.5 text-sm font-semibold leading-6 text-white shadow-sm bg-indigo-600 hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
              >
                Sign Up
              </button>
            </div>
          </form>

          <p className="mt-6 sm:mt-10 text-center text-sm text-gray-500">
            Already a member?{' '}
            <button 
              className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setShowLoginModal(true);
                setShowSignupModal(false);
              }}
            >
              Sign in now.
            </button>
          </p>
        </div>

        {/* <div className='flex items-center justify-center mt-6'>
          <button 
            className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" 
            onClick={() => setShowSignupModal(false)}
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  );
}

export default SignupModal;